

































































































import { Component, Vue } from 'vue-property-decorator';
import { CURRENCY_FORMAT } from '@/helpers/currency';
import cCard from '@/components/default/Card.vue';
import machineryEventsRepository from '@/modules/machinery/services/machineryEventsRepository';
import machineryEventTypesRepository from '@/modules/machinery/services/machineryEventTypesRepository';
import notificationService from '@/services/notificationService';
import cPopup from '@/components/default/Popup.vue';
import {
  DxForm,
  DxSimpleItem,
  DxRequiredRule,
  DxGroupItem,
  DxLabel,
} from 'devextreme-vue/form';

import EventLogsTable from '@/modules/shared/eventlogs/components/EventLogsTable.vue';

import FileManager from '@/modules/documents/FileManager.vue';
import { DxTabs } from 'devextreme-vue';

@Component({
  components: {
    DxTabs,
    cCard,
    cPopup,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxLabel,
    EventLogsTable,
    FileManager,
  },
})
export default class MachineryEventDetailPage extends Vue {
  private item: IMachineryEvent | null = null;
  private loading: boolean = true;
  private navIndex: number = 0;
  private saving: boolean = false;
  private showDialogValue: boolean = false;
  private eventTypes: IMachineryEventType[] = [];
  private eventModal: IMachineryUpdateEventCommand = {
    id: '',
    machineryId: '',
    eventTypeId: '',
    description: '',
    title: '',
    date: '',
    price: null,
    operatingHours: null,
  };

  private mounted() {
    this.loadData();
    this.loadEventTypesAsync();
  }

  private async loadEventTypesAsync() {
        try {
            this.eventTypes = (await machineryEventTypesRepository.getAll()).data;
        } catch (err) {
            notificationService.showAxiosError(err);
        }
    }

  private async loadData() {
    try {
      this.loading = true;
      this.item = (await machineryEventsRepository.getSingle(this.$route.params.id)).data;
      Object.assign(this.eventModal, this.item);
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.loading = false;
    }
  }

  private async saveEvent() {
    try {
      const validationResult = (this.$refs.machineryEventForm as any).instance.validate();
      if (validationResult.isValid) {
        this.saving = true;
        await machineryEventsRepository.update(this.eventModal);
        this.loadData();
        notificationService.saved();
        this.showDialogValue = false;
      } else {
        notificationService.invalidForm();
      }
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }

  get navbarItems() {
    return [
      { icon: 'fas fa-info-circle', text: 'Info'},
      { icon: 'fas fa-folder', text: 'Documenten'},
      { icon: 'fas fa-history', text: 'Geschiedenis'},
    ];
  }

  get historyConfig(): IEventLogQuery {
    return {
      objectId: this.$route.params.id,
      type: 19,
    };
  }

  get content() {
    if (this.item && this.item.description) {
      let text = '' + this.item.description;
      while (text.indexOf('\n') !== -1) {
        text = text.replace('\n', '<br />');
      }

      return text;
    }

    return '';
  }

  get eventFields() {
    return [
        {
            itemType: 'simple',
            dataField: 'eventTypeId',
            editorOptions: {
                items: this.eventTypes,
                displayExpr: 'name',
                valueExpr: 'id',
                searchEnabled: true,
                itemTemplate: (e: any) => {
                    let customHtml = e.name;
                    if (e.icon) {
                        customHtml = '<i class="fas ' + e.icon + '"></i>&nbsp;' + customHtml;
                    }

                    return customHtml;
                },
            },
            editorType: 'dxSelectBox',
            label: {
                text: this.$t('objects.machineryEvent.fields.Type'),
            },
            validationRules: [
                {type: 'required', message: 'Veld is verplicht'},
            ],
        },
        {
            itemType: 'simple',
            dataField: 'title',
            label: {
                text: this.$t('objects.machineryEvent.fields.Title'),
            },
            validationRules: [
                {type: 'required', message: 'Veld is verplicht'},
            ],
        },
        {
            itemType: 'simple',
            dataField: 'date',
            editorOptions: { width: '100%', useMaskBehavior: true },
            editorType: 'dxDateBox',
            label: {
                text: this.$t('objects.machineryEvent.fields.Date'),
            },
            validationRules: [
                {type: 'required', message: 'Veld is verplicht'},
            ],
        },
        {
            itemType: 'group',
            colCount: 2,
            items: [
                {
                    itemType: 'simple',
                    dataField: 'price',
                    editorType: 'dxNumberBox',
                    editorOptions: {
                        format: CURRENCY_FORMAT,
                    },
                    label: {
                        text: this.$t('objects.machineryEvent.fields.Price'),
                    },
                },
                {
                    itemType: 'simple',
                    dataField: 'operatingHours',
                    editorType: 'dxNumberBox',
                    label: {
                        text: 'Draaiuren / KM-stand',
                    },
                },
            ],
        },
        {
            itemType: 'simple',
            dataField: 'description',
            editorType: 'dxTextArea',
            editorOptions: { height: '150'},
            label: {
                text: this.$t('objects.machineryEvent.fields.Description'),
            },
        },
    ];
  }

}
